import "./App.scss";
import Landing from "./components/landing/Landing.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Login/Login";
import Claim from "./components/Claim/Claim";
import useEagerConnect from "./hooks/useEagerConnect";
import ClaimNft from "./components/Claim/ClaimNft";
import { useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Staking from "./components/Staking/Staking.js";
import Password from "./components/Login/Password.js";
import ProtectedRoute from "./ProtectRoute.js";
import Faqs from "./components/Faqs/Faqs.js";
import IntercomComponent from "./Intercom/Intercom.js";
import Educationalvideo from "./components/Educationalvideo/Educationalvideo.js";

function App() {
  const [countryyName, setCountryyName] = useState(null);
  const [showservice, setShowService] = useState(false);

  const handleCloseService = () => setShowService(false);
  const handleShowService = () => setShowService(true);

  useEagerConnect();

  // === Multi-API fallback for IP & Country ===
  const get_ApiKeys = async () => {
    const ipApis = [
      {
        name: "ipapi.co",
        url: "https://ipapi.co/json/",
        parser: (data) => ({ ip: data.ip, country: data.country_name }),
      },
      {
        name: "ipify + ipapi",
        url: "https://api.ipify.org?format=json",
        parser: (data) => ({ ip: data.ip, country: null }),
        requiresSecondCall: true,
      },
      {
        name: "ip-api.com",
        url: "http://ip-api.com/json/",
        parser: (data) => ({ ip: data.query, country: data.country }),
      },
      {
        name: "geojs.io",
        url: "https://get.geojs.io/v1/ip/geo.json",
        parser: (data) => ({ ip: data.ip, country: data.country }),
      },
      {
        name: "ipwhois.app",
        url: "http://ipwhois.app/json/",
        parser: (data) => ({ ip: data.ip, country: data.country }),
      },
    ];

    for (const api of ipApis) {
      try {
        console.log(`Trying ${api.name}...`);

        const response = await axios({
          method: "get",
          url: api.url,
          timeout: 5000,
        });

        const parsed = api.parser(response.data);

        if (parsed.ip) {
          localStorage.setItem("ip", parsed.ip);

          if (parsed.country) {
            localStorage.setItem("country", parsed.country.toLowerCase());
            handleCountryCheck(parsed.country.toLowerCase());
            return;
          } else if (api.requiresSecondCall) {
            await get_ApiKeys1(parsed.ip);
            return;
          }
        }
      } catch (error) {
        console.log(`${api.name} failed:`, error.message);
        continue;
      }
    }

    console.log("All IP APIs failed, using fallback");
    setShowService(false);
    localStorage.setItem("country", "india");
  };

  const get_ApiKeys1 = async (ip) => {
    const countryApis = [
      {
        name: "ipapi.co",
        url: `https://ipapi.co/${ip}/json/`,
        parser: (data) => data.country_name,
      },
      {
        name: "ip-api.com",
        url: `http://ip-api.com/json/${ip}`,
        parser: (data) => data.country,
      },
      {
        name: "geojs.io",
        url: `https://get.geojs.io/v1/ip/geo/${ip}.json`,
        parser: (data) => data.country,
      },
    ];

    for (const api of countryApis) {
      try {
        console.log(`Trying ${api.name} for country...`);

        const response = await axios({
          method: "get",
          url: api.url,
          timeout: 5000,
        });

        const country = api.parser(response.data);

        if (country) {
          localStorage.setItem("country", country.toLowerCase());
          handleCountryCheck(country.toLowerCase());
          return;
        }
      } catch (error) {
        console.log(`${api.name} failed:`, error.message);
        continue;
      }
    }

    console.log("All country APIs failed, using fallback");
    setShowService(false);
    localStorage.setItem("country", "india");
  };

  const handleCountryCheck = (country) => {
    const restrictedCountries = [
      "south sudan",
      "southsudan",
      "afghanistan",
      "yemen",
      "myanmar",
      "united states",
      "unitedstates",
      "iran",
      "north korea",
      "northkorea",
      "syria",
      "lebanon",
      "america",
      "usa",
    ];

    const isRestricted = restrictedCountries.some((restricted) =>
      country.includes(restricted),
    );

    if (isRestricted) {
      setShowService(true);
      setCountryyName(country);
    } else {
      setShowService(false);
    }
  };

  useEffect(() => {
    get_ApiKeys();
  }, []);

  return (
    <>
      <ToastContainer
        autoClose={false}
        style={{ fontSize: 12, fontWeight: 300 }}
        theme="light"
        position="top-center"
      />
      <Router>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/buy" component={Landing} />
          <Route exact path="/claim" component={Claim} />
          <Route exact path="/faqs" component={Faqs} />
          <Route exact path="/education-videos" component={Educationalvideo} />
          <Route exact path="/ClaimNft" component={ClaimNft} />
          {/* <Route exact path="/discount" component={Staking} /> */}
        </Switch>
      </Router>
      <IntercomComponent />
      <Modal
        className="service-modal"
        backdrop="static"
        keyboard={false}
        show={showservice}
        onHide={handleCloseService}
        centered
      >
        <Modal.Body>
          <div className="upper-div">
            <img src="\ic_round-warning.svg" alt="img" className="img-fluid" />
            <h6>Service Unavailable</h6>
          </div>
          <div className="bottom-div">
            <h6>The Service is Unavailable in Your Region</h6>
            <p>
              We're sorry, but the service you are trying to access is not
              available in {countryyName}.
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default App;
